import GrammarDescriptionFlag from 'components/grammar_description_flag';
import React from 'react';
import { observer } from 'mobx-react';
import { TreeNodeGrammarWrapper } from '@seedlang/hoc';
import styled from '@emotion/styled';
import TextDisplay from 'components/text_display';
import Spinner from 'components/spinner';
import Text from 'components/text';

const Wrapper = styled.div`
  font-size: 14px;
  .grammar-section:not(:last-child) {
    margin-bottom: 20px;
  }
`;

@observer
class TreeNodeGrammar extends React.Component {

  render() {
    const grammarDescription = this.props.treeNode?.grammarDescription;
    const treeNodeGrammarConcepts = this.props.treeNode?.treeNodeGrammarConcepts || [];
    const showConcepts = !this.props.treeNode?.grammarDescriptionOverride && treeNodeGrammarConcepts.some(item => item.concept?.longDescription);

    return (
      <Wrapper>
        {
          this.props.showSpinner &&
            <Spinner />
        }
        {
          !this.props.showSpinner && !showConcepts && grammarDescription &&
            <>
              <TextDisplay
                htmlText={grammarDescription}
              />
              <GrammarDescriptionFlag key={this.props.treeNode.id} treeNodeId={this.props.treeNode.id} />
            </>
        }
        {
          !this.props.showSpinner && showConcepts && treeNodeGrammarConcepts.map(grammarConcept => {
            if (grammarConcept.concept) {
              return (
                <div
                  className='grammar-section'
                  key={grammarConcept.id}
                >
                  <Text heading='3'>{grammarConcept.concept.displayNameLine1WithCase}</Text>
                  {
                    grammarConcept.concept.displayNameLine2 &&
                    <Text italic fontSize='14px'>{grammarConcept.concept.displayNameLine2}</Text>
                  }
                  {
                    grammarConcept.concept.longDescription &&
                    <>
                      <TextDisplay
                        htmlText={grammarConcept.concept.longDescription}
                      />
                      <GrammarDescriptionFlag key={grammarConcept.concept?.id} conceptId={grammarConcept.concept?.id} languageId={grammarConcept.concept?.grammarDescriptionLanguageId} />
                    </>
                  }
                </div>
              );
            } else {
              return null;
            }
          })
        }
      </Wrapper>
    );
  }
}

export default TreeNodeGrammarWrapper(TreeNodeGrammar);
